<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :closable="true"
    :confirmLoading="confirmLoading"
    :bodyStyle="{ paddingBottom: '80px'}"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <slot></slot>
    </a-spin>
    <!-- <div :style="styleObject" v-if="footer">
      <a-button type="primary" @click="handleCancel">{{ cancelButtonName }}</a-button>
      <a-button type="primary" @click="handleOk" style="margin-left: 20px">{{ okButtonName }}</a-button>
    </div> -->
  </a-drawer>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 434,
    },
    height: {
      type: Number,
      default: 600,
    },
    footer: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false,
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    cancelButtonName: {
      type: String,
      default: '取消',
    },
    okButtonName: {
      type: String,
      default: '提交',
    }
  },
  data() {
    return {
      styleObject: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      },
    }
  },
  methods: {
    handleCancel() {
      this.$emit('handleCancel')
    },
    handleOk() {
      this.$emit('handleOk')
    },
  },
}
</script>

<style lang="less" scoped>
// /deep/ .ant-drawer {
//     width: 100%;
//     height: 50%;
// }
</style>
